<template>
  <div class="product-specs-wrap">
    <div class="gallery-side">
      <div class="col-lg-6 p-l-0 product__big-img-gallery">
        <div class="featured-image">
            <div class="offer--cards__bg product-photo" id="ProductPhoto">
                <img id="ProductPhotoImg" class="zoom_mouse product_variant_image" :src="item.gallery[item.selectedImageIndex]">
            </div>
        </div>
        <div class="shop-product__small-image-gallery-wrapper">
            <div class="shop-product__small-image-gallery-slider owl-carousel owl-loaded owl-drag" id="ProductThumbs">
              <div class="direction-wrap left" @click="leftScrolling">
                <img src="/images/offes-news-img/chevron-left.png" alt="">
              </div>
              <div class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all 0s ease 0s;">
                <div v-for="(photo, i) in item.gallery" class="carousel-item" :class="{active: i == 0}" :key="i" @click="galleryChange(i)">
                  <img :src="photo">
                </div>
              </div>
              <div class="direction-wrap right" @click="rightScrolling">
                <img src="/images/offes-news-img/chevron-right.png" alt="">
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="specs-side">
      <h2>{{ item.name }}</h2>
      <div class="stars-wrap">
        <div class="star" v-for="n in 5" :key="n">
          <img  v-if="item.stars < n" src="/images/offes-news-img/empty-star.png">
          <img  v-else src="/images/offes-news-img/star.png">
        </div>
      </div>
      <div class="value-group">
        <div class="regular-title">Valor: </div>
        <div class="price-value">
          <span class="currency-wrap">RD$</span>
          <span class="price">22,000</span>
          <span class="decimals">.00</span>
        </div>
      </div>
      <div class="key-switch space">
        <div class="value-group">
          <div class="regular-title">{{ item.optionsType }}:</div>
          <div class="regular-size-value">{{ item.productOptions[item.defaultOptionIndex].name }}</div>
        </div>
        <div class="options-wrap">
          <div v-for="(option, i) in item.productOptions" class="option" :key="i" @click="changeOption(i)">{{ option.name }}</div>
        </div>
      </div>
      <div class="prices-plan">
        <div class="value-group">
          <div class="regular-title">Monto Pre-aprobado: </div>
          <div class="value-with-background gray">DOP$ {{ item.preApprovedAmount.toLocaleString() }}</div>
        </div>
        <div class="value-group">
          <div class="regular-title">Monto Disponible: </div>
          <div class="value-with-background gray">DOP$ {{ item.userBalance.toLocaleString() }}</div>
        </div>
        <div class="value-group">
          <div class="regular-title">Monto Plan de Pagos: </div>
          <div class="value-with-background gray">DOP$ {{ item.paysPlan.toLocaleString() }}</div>
        </div>
        <div class="value-group">
          <div class="regular-title">Cuotas Plan de Pago: </div>
          <div class="value-with-background">{{ item.quotas.toLocaleString() }} Cuotas</div>
        </div>
      </div>
      <div class="dragged-value-wrap">
        <div class="value-group">
          <div class="regular-title">Monto abono del cliente:</div>
        </div>
        <div id="draggerParent"></div>
        <!-- DRAG COMPONENT HERE -->
      </div>
      <div class="request-product-btn">Solicitar</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'product-detail-specs',
  props: {
    item: Object
  },
  data: () => {
    return {
      item: {
        name: 'Samsung Galaxy S9 Plus',
        category: 'Samsung',
        price: 22500,
        stars: 4,
        selectedImageIndex: 0,
        preApprovedAmount: 10000,
        userBalance: 5000,
        paysPlan: 1200,
        quotas: 10,
        draggedValue: 12000,
        optionsType: 'Tamaño',
        defaultOptionIndex: 0,
        productOptions: [
          {
            name: '64gb'
          },
          {
            name: '32gb'
          },
          {
            name: '16gb'
          }
        ],
        gallery: [
          'https://www.mobiledokan.co/wp-content/uploads/2018/10/samsung-galaxy-s9-plus.jpg',
          'https://mlstaticquic-a.akamaihd.net/tapa-trasera-samsung-galaxy-s9-plus-purpura-coloc-zonalaptop-D_NQ_NP_951732-MLU27872891719_072018-F.jpg',
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBHVOrJOrneGJztnVJ0DZkbpo7eAIHr8nVmxjV2_fcLegYc9oAmA&s',
          'https://www.einfo.co.nz/media/catalog/product/cache/0ee050c3ffc3555709b9bb6062f4d7e9/s/a/samsung-galaxy-s9-plus-g965f-64gb-dual-sim-black_1.jpg',
          'https://images-na.ssl-images-amazon.com/images/I/711nHduIYxL._SX425_.jpg',
          'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBHVOrJOrneGJztnVJ0DZkbpo7eAIHr8nVmxjV2_fcLegYc9oAmA&s',
          'https://www.einfo.co.nz/media/catalog/product/cache/0ee050c3ffc3555709b9bb6062f4d7e9/s/a/samsung-galaxy-s9-plus-g965f-64gb-dual-sim-black_1.jpg',
          'https://images-na.ssl-images-amazon.com/images/I/711nHduIYxL._SX425_.jpg'
        ]
      }
    }
  },
  methods: {
    leftScrolling: function () {
      let carouselContent = document.querySelector('.owl-stage')
      carouselContent.scroll({
        left: carouselContent.scrollLeft - (carouselContent.offsetWidth / 2),
        behavior: 'smooth'
      })
    },
    rightScrolling: function () {
      let carouselContent = document.querySelector('.owl-stage')
      carouselContent.scroll({
        left: carouselContent.scrollLeft + (carouselContent.offsetWidth / 2),
        behavior: 'smooth'
      })
    },
    galleryChange: function (index) {
      this.item.selectedImageIndex = index
    },
    changeOption: function (index) {
      this.item.defaultOptionIndex = index
    }
  },
  created: () => {
    // let el = document.querySelector('#draggerParent')
    // try {
    //   greenDragger({
    //     el,
    //     max: 22000,
    //     percent: 12
    //   })
    // } catch (err) { alert(err) }
  }
}
</script>

<style lang="css" scoped>
  .product-specs-wrap {
    width: 1000px;
    max-width: 1000px;
    margin: 0 auto;
    display: flex;
  }

  .product-specs-wrap > div {
    width: 50%;
  }

  .stars-wrap {
    display: flex;
  }

  .stars-wrap img {
    width: 10px;
    height: 10px;
    margin-right: 3px;
  }

  .specs-side {
    padding-left: 25px;
  }

  .specs-side > h2 {
    text-align: left;
    margin-bottom: 5px;
    font-weight: 900;
  }

  .value-group {
    display: flex;
    font-size: 13px;
    padding: 10px 0;
    align-items: center;
  }

  .regular-title {
    margin-right: 7px;
  }

  .price-value {
    display: flex;
    align-items: center;
  }

  .price-value > .currency-wrap {
    font-size: 9px;
    margin-right: 5px;
  }

  .price-value .price {
    font-size: 20px;
  }

  .price-value > .decimals {
    font-size: 9px;
    margin-left: 3px;
  }

  /* Product options */

  .key-switch {
      margin-bottom: 8px;
  }

  .key-switch > .value-group {
      padding-top: 0;
  }

  .key-switch > .options-wrap {
    display: flex;
    padding-top: 5px;
  }

  .key-switch > .options-wrap > .option {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    border: 1px dashed #ccc;
    width: 65px;
    font-size: 12px;
    font-weight: 900;
    margin-right: 7px;
    cursor: pointer;
    box-sizing: border-box;
    -webkit-transition: all .2s;
    transition: all .2s;
  }

  .key-switch > .options-wrap > .option:hover {
    border: 2px dashed #ccc;
  }

  .key-switch > .options-wrap > .option.active {
    color: #213F99  ;
    border: 1px solid #213F99;
  }

  .key-switch .regular-size-value {
      font-weight: 900;
  }

  /* Plans style */

  .prices-plan {
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 10px;
  }

  .prices-plan > div {
    display: flex;
    /* width: 50%; */
  }

  .prices-plan > .value-group {
    flex-flow: column;
    align-items: flex-start;
    width: 100%;
  }

  .prices-plan .value-group > div {
    width: 100%;
    text-align: left;
  }

  .prices-plan .value-group .value-with-background {
    border: 2px solid #eee;
    padding: 5px 7px;
    box-sizing: border-box;
    margin-top: 7px;
    font-weight: 900;
  }

  .prices-plan .value-group .value-with-background.gray {
    background-color: #eee;
  }

  .request-product-btn {
    margin-top: 10px;
    height: 40px;
    background-color: #38B449;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: 900;
    text-transform: uppercase;
    font-size: 12px;
    cursor: pointer;
  }

  /* GALLERY CSS */

  .gallery-side {
    padding-right: 25px;
    padding-top: 30px;
  }

  img {
    max-width: 100%;
  }
  h1 {
      font-size: 26px;
  }
  a {
      color:#213F99;
  }
  a:hover {
      text-decoration: underline;
      color:#213F99;
  }
  /* Breadcrum */
  .breadcrumb {
      margin-bottom: 0px;
      text-transform: capitalize;
  }
  .breadcrumb li.active {
      color: #000000;
  }
  .breadcrumb li a {
      color: #898989;
  }

  /* Classification Star */

  .stars--item {
      text-align: left;
      max-width:150px;
      width: 100%;
      height: 38px;
  }
  .devices-table {
      margin: 30px 0 15px;
  }
  .devices-table tr {
      border-bottom: 1px solid #d4d9ddbd;
  }
  .devices-table td {
      color: #213F99;
  }
  .devices-info p,
  .devices-table tr,
  .devices-table td {
      font-size: 16px;
  }
  .table-header__devices {
      background: #F5F5F5;
      padding: 15px 30px;
  }
  .product-detail .offer--cards__bg {
      padding: 30px 40px;
  }
  .offer--cards__bg {
      background: #fff;
      border: 1px solid #ccc;
  }
  .sign-price,
  .currency-price {
    vertical-align: middle;
  }
  .currency-price {
    font-size: 24px;
  }

  .cent-price {
    vertical-align: sub;
    margin-left: -5px;
  }

  .devices-detail__container {
    margin-bottom: 40px;
  }

  .product-photo {
    text-align: center;
    margin-bottom: 25px;
  }

  .carousel-item {
    width: auto;
    margin-right: 8px;
    border: 1px solid #ddd;
    background-color: white;
    cursor: pointer;
  }

  .carousel-item.active {
    border: 2px solid #aaa;
  }

  .carousel-item img {
    max-height: 75px;
    height: 75px;
    width: auto;
    min-width: 60px;
  }

  .owl-stage {
    display: flex;
    flex: 1;
    overflow-x: auto;
  }

  .owl-stage::-webkit-scrollbar {
    display: none;
  }

  /* Review Clients */

  .review-container {
    max-height: 218px;
    height: 100%;
    padding: 0px 40px!important;
    margin: 15px 0 0px;
  }

  .review-container__users {
    text-align: center;
    padding: 20px;
  }

  .review-container__users span {
    display: block;
    margin: 15px 0 0px;
    font-size: 16px;
  }
  .review-container__text {
    padding: 50px 35px 20px;
    font-size: 16px;
    color: #707070;
  }

  #ProductPhoto {
    max-height: 400px;
    min-height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #ProductPhoto img {
    max-height: inherit;
    height: inherit;
    width: auto;
  }

  .direction-wrap {
    display: flex;
    align-items: center;
    width: 40px;
    height: 100%;
    color: #cccc;
    opacity: 0.5;
    cursor: pointer;
  }

  .direction-wrap.right {
    justify-content: flex-end;
  }

  .direction-wrap img {
    width: 15px;
    height: auto;
  }

  #ProductThumbs {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// product-detail-specs.vue?81bca710